import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetolonavalacabbooking() {



  const cardData =
  {
    keyword: 'Pune to Lonavala Cab Booking',
    heading: 'Sai Trupti Cabs: Pune to Lonavala Cab Booking',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune to Lonavala cab booking services, designed to make your inter-city journey smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles— all equipped with clean interiors and ample luggage space. Every journey is driven by a professional, background-verified chauffeur who ensures punctual pickup in Pune, courteous service, and safe, smooth driving all the way to Lonavala. With transparent one-way fares, flexible booking options (one-way or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your travel from Pune to Lonavala convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Lonavala with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Tiger’s Leap (Tiger Point)",
    "description": "Tiger’s Leap, also known as Tiger Point, is one of Lonavala’s most spectacular viewpoints located about 12 kilometers from the main town. The cliff, shaped like a leaping tiger, offers breathtaking panoramic views of deep valleys, mist-clad hills, and cascading waterfalls during the monsoon. The echoing sound of the wind and the roar of waterfalls create a thrilling experience for every visitor. Adventure lovers enjoy trekking and photography here, while others sip hot tea and corn from local stalls. Whether blanketed in fog or kissed by golden sunsets, Tiger’s Leap captures the wild beauty of the Sahyadris perfectly."
  },
  {
    "title": "Bhushi Dam",
    "description": "Bhushi Dam is the heart of Lonavala’s monsoon magic, attracting crowds for its gushing overflow and playful water streams. Built on the Indrayani River, the dam transforms into a natural waterfall when the reservoir overflows, creating steps where visitors sit and splash in cool water. Surrounded by green hills and chirping birds, it becomes a lively picnic spot during the rainy season. Families, friends, and couples gather here for fun and relaxation amidst nature’s rhythm. Bhushi Dam is where laughter, water, and mountain mist merge into pure joy."
  },
  {
    "title": "Rajmachi Fort",
    "description": "Rajmachi Fort is a historic twin-fort complex (Shrivardhan and Manaranjan) that stands proudly overlooking the Bor Ghat valley. Built during the Maratha Empire, it offers panoramic views of the Sahyadri range and shimmering waterfalls. The trek to Rajmachi, especially from Udhewadi or Kondane caves, is a favorite among adventure enthusiasts. During monsoon, the fort is wrapped in clouds, making the climb both mystical and breathtaking. Rajmachi symbolizes the courage and strategic brilliance of the Marathas, while today it draws trekkers seeking history, adventure, and natural splendor all in one."
  },
  {
    "title": "Lonavala Lake",
    "description": "Nestled amidst the lush green hills, Lonavala Lake is a tranquil retreat located a few kilometers from the town center. Filled by monsoon rains, the lake becomes a picturesque picnic spot where visitors can relax, birdwatch, or simply gaze at the serene waters. During early mornings, mist floats over the lake creating a dreamlike atmosphere. Local vendors line the banks selling tea, vada-pav, and roasted corn. In every sense, Lonavala Lake captures the essence of this hill station — peaceful, scenic, and refreshingly simple."
  },
  {
    "title": "Karla Caves",
    "description": "The Karla Caves, dating back over 2,000 years, are among India’s finest examples of ancient Buddhist rock-cut architecture. Carved into the hillside, these caves feature impressive chaityas (prayer halls), intricate pillars, and sculptures depicting life from the 2nd century BCE. The main hall, with its towering wooden ceiling and grand stupa, radiates a sense of calm and devotion. Climbing the stone steps to reach the caves rewards visitors with both spiritual peace and panoramic valley views. For history enthusiasts and architecture admirers, Karla Caves are a journey into timeless art and faith."
  },
  {
    "title": "Lohagad Fort",
    "description": "Lohagad Fort, meaning ‘Iron Fort,’ stands tall at 1,033 meters above sea level and has witnessed centuries of Maratha glory. Once used by Chhatrapati Shivaji Maharaj to store treasure, the fort’s massive gates and long wall resembling a scorpion’s tail (‘Vinchu Kata’) are striking features. Trekkers love the route for its moderate climb and rewarding views of the Pawna Lake below. During monsoon, the fort is covered in mist and greenery, creating an otherworldly landscape. Lohagad beautifully combines history, adventure, and natural beauty, making it a must-visit in Lonavala."
  },
  {
    "title": "Bhaja Caves",
    "description": "The Bhaja Caves, a cluster of 22 ancient rock-cut Buddhist shrines, date back to the 2nd century BCE and showcase the artistic mastery of the early Hinayana period. The main chaitya with its horseshoe-shaped arch and wooden ribs still evokes the sacred sound of prayer. Located close to Karla Caves, Bhaja offers intricate carvings, stupas, and stunning hillside views. A short trek leads visitors to this tranquil heritage site where stone, history, and silence come together. It’s an ideal destination for those who love archaeology, meditation, and mountain serenity."
  },
  {
    "title": "Duke’s Nose",
    "description": "Duke’s Nose, named after the Duke of Wellington’s pointed nose shape, is a thrilling cliff point near Lonavala offering panoramic views of the Western Ghats. It’s a favorite spot for rock climbing, rappelling, and trekking adventures. The viewpoint overlooks deep valleys and green slopes, especially mesmerizing during the monsoon. At sunrise, the clouds roll below your feet, giving an illusion of walking above the sky. For thrill-seekers and photographers, Duke’s Nose promises unmatched adrenaline and beauty rolled into one majestic viewpoint."
  },
  {
    "title": "Pawna Lake",
    "description": "Pawna Lake is an idyllic reservoir surrounded by misty hills, just a short drive from Lonavala. Formed by the Pawna Dam, this lake has become a favorite destination for camping and stargazing. At night, tents dot the lakeside as visitors enjoy bonfires, barbecue meals, and the calm reflection of stars on water. With the backdrop of Lohagad, Tikona, and Tung forts, Pawna offers both scenic beauty and adventure. Whether for couples seeking romance or families wanting tranquility, Pawna Lake is the perfect nature getaway."
  },
  {
    "title": "Ryewood Park and Shivaji Garden",
    "description": "Ryewood Park and Shivaji Garden are peaceful green lungs in the center of Lonavala town. Sprawling lawns, shady trees, and colorful flowerbeds make it a refreshing spot for morning walks and family outings. Within the park lies a small Shiva temple that adds a touch of spirituality to the setting. The cool breeze, chirping birds, and well-maintained paths make it a perfect picnic escape. It’s an ideal place to relax after exploring Lonavala’s many viewpoints, reflecting the hill station’s calm and timeless charm."
  }
],



"services": [
  {
    "name": "Pune to Lonavala Cab Booking",
    "description": "Book your Pune to Lonavala cab online for a smooth and scenic drive through the Western Ghats. Enjoy flexible pickup and drop options, AC/non-AC vehicles, professional drivers, and transparent pricing for hassle-free hill station travel. Perfect for weekend getaways, family trips, and romantic escapes."
  },
  {
    "name": "Pune to Lonavala Taxi",
    "description": "Hire a taxi from Pune to Lonavala with reliable service, comfortable cars, AC/non-AC options, and professional chauffeurs. Whether for sightseeing, leisure, or business trips, experience safe, punctual, and comfortable travel with real-time booking convenience."
  },
  {
    "name": "Pune to Lonavala Car Hire",
    "description": "Rent a car from Pune to Lonavala for a personalized and relaxing journey. Choose from Sedans, SUVs, and luxury vehicles with AC/non-AC facilities, professional drivers, luggage support, and flexible scheduling for your travel needs."
  },
  {
    "name": "Pune to Lonavala AC Cab",
    "description": "Travel comfortably in an air-conditioned cab from Pune to Lonavala. Enjoy cool interiors, clean vehicles, and experienced drivers for a safe and relaxing trip through the beautiful Sahyadri hills — ideal for families and tourists."
  },
  {
    "name": "Pune to Lonavala Non AC Cab",
    "description": "Budget-friendly non-AC cab service from Pune to Lonavala offering reliable vehicles, skilled drivers, and flexible pickup/drop options. Perfect for economical travel without compromising on comfort and safety."
  },
  {
    "name": "Pune to Lonavala Luxury Cab",
    "description": "Experience premium travel with luxury cabs from Pune to Lonavala featuring stylish interiors, AC comfort, and professional chauffeurs. Ideal for weddings, corporate travel, or VIP guests who seek an elevated and elegant travel experience."
  },
  {
    "name": "Pune to Lonavala Innova Cab",
    "description": "Book a spacious and comfortable Innova cab from Pune to Lonavala. With seating for up to 7 passengers, AC options, and experienced drivers, it’s perfect for family trips, group tours, and long scenic drives."
  },
  {
    "name": "Pune to Lonavala Ertiga Cab",
    "description": "Affordable and comfortable Ertiga cabs from Pune to Lonavala with AC/non-AC options, spacious seating, luggage support, and skilled drivers. Great for small groups, families, or friends traveling together for a weekend retreat."
  },
  {
    "name": "Pune to Lonavala Outstation Cab",
    "description": "Reliable outstation cab service from Pune to Lonavala ideal for leisure trips, sightseeing, or weekend breaks. Enjoy AC/non-AC options, flexible timings, professional chauffeurs, and transparent fares for a stress-free experience."
  },
  {
    "name": "Pune to Lonavala Drop Cab",
    "description": "Book one-way drop cab service from Pune to Lonavala with affordable fares, professional drivers, AC/non-AC options, and flexible pickup locations. Ideal for those heading to Lonavala without return travel plans."
  },
  {
    "name": "Affordable Pune to Lonavala Cab",
    "description": "Pocket-friendly Pune to Lonavala cab services offering AC/non-AC options, clean vehicles, professional drivers, and flexible pickup/drop schedules. Perfect for students, solo travelers, and families looking for economical travel."
  },
  {
    "name": "Pune to Lonavala One Way Cab",
    "description": "One-way cab service from Pune to Lonavala providing flexible travel, AC/non-AC options, experienced drivers, and transparent fares. Enjoy convenient and affordable travel without the cost of a round trip."
  },
  {
    "name": "Pune to Lonavala Corporate Cab",
    "description": "Corporate cab hire from Pune to Lonavala offering executive Sedans and SUVs, professional chauffeurs, AC comfort, and flexible scheduling. Ideal for business meetings, team outings, or corporate retreats."
  },
  {
    "name": "Pune to Lonavala Wedding Cab",
    "description": "Elegant wedding cab service from Pune to Lonavala with luxury vehicles, AC/non-AC options, professional chauffeurs, and punctual service. Perfect for wedding guests, family travel, and event logistics."
  },
  {
    "name": "Pune to Lonavala Online Booking",
    "description": "Book your Pune to Lonavala cab online instantly with secure payments, AC/non-AC options, experienced drivers, and flexible pickup/drop timings. A quick and reliable way to plan your next trip to Lonavala."
  }
],
"tableData": [
  ["Pune to Lonavala Cab Booking", "Pune to Lonavala Taxi"],
  ["Pune to Lonavala Car Hire", "Pune to Lonavala AC Cab"],
  ["Pune to Lonavala Non AC Cab", "Pune to Lonavala Luxury Cab"],
  ["Pune to Lonavala Innova Cab", "Pune to Lonavala Ertiga Cab"],
  ["Pune to Lonavala Outstation Cab", "Pune to Lonavala Drop Cab"],
  ["Affordable Pune to Lonavala Cab", "Pune to Lonavala One Way Cab"],
  ["Pune to Lonavala Corporate Cab", "Pune to Lonavala Wedding Cab"],
  ["Pune to Lonavala Online Booking", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Lonavala Cab Booking",
    "WhyChoosedescription": "Sai Trupti Cabs  provides reliable and comfortable cab services from Pune to Lonavala — ideal for weekend getaways, hill station trips, and leisure travel."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Get clear one-way fare estimates for Pune to Lonavala cabs, starting at affordable rates depending on the car type — no hidden charges or last-minute surprises."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, or premium cars to suit your group size, luggage, and comfort preferences for the Pune–Lonavala route."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers are familiar with the Pune to Lonavala route, ensuring a safe, smooth, and timely journey through scenic roads."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We provide pickups from anywhere in Pune (city, airport, or suburbs) and drop-offs at Lonavala hotels, resorts, or residences."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All our cabs are regularly serviced, sanitized, and maintained to ensure comfort and reliability for your hill station trip."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated team is available round-the-clock to assist with bookings, route planning, or any travel queries."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Lonavala cab easily via call, WhatsApp, or our website — with instant confirmation and prompt vehicle dispatch."
  }
]























  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Pune to Lonavala cab booking services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable Pune to Lonavala cab booking services for one way, round trips, and weekend getaways.',
  },
  {
    question: 'How can I book a cab from Pune to Lonavala with Sai Trupti Cabs?',
    answer: 'You can easily book your Pune to Lonavala cab through our website, mobile app, or by calling our 24×7 customer support team for quick booking assistance.',
  },
  {
    question: 'What cab options are available for Pune to Lonavala travel?',
    answer: 'We offer a wide range of vehicles including hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers—perfect for family trips, corporate travel, and couples getaways.',
  },
  {
    question: 'Are the drivers experienced for the Pune to Lonavala route?',
    answer: 'Yes, all our drivers are well-trained, polite, and experienced in driving along the Pune–Lonavala Expressway, ensuring a safe and enjoyable ride.',
  },
  {
    question: 'Can I book a cab for sightseeing in and around Lonavala?',
    answer: 'Certainly. We provide full-day sightseeing cabs for popular attractions such as Bhushi Dam, Tiger’s Leap, Lion’s Point, and Karla Caves.',
  },
  {
    question: 'Is the Pune to Lonavala cab booking service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 Pune to Lonavala cab booking services so you can plan your journey anytime at your convenience.',
  },
  {
    question: 'What are the Pune to Lonavala cab fares?',
    answer: 'Our Pune to Lonavala cab fares start from ₹1,800 for sedans and ₹2,500–₹3,500 for SUVs or premium vehicles, depending on your chosen cab type and trip duration.',
  },
  {
    question: 'What payment options are available for Pune to Lonavala cab booking?',
    answer: 'We accept payments through UPI, credit/debit cards, digital wallets, and bank transfers for a smooth and secure transaction experience.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Pune to Lonavala cabs?',
    answer: 'All our vehicles are sanitized before every trip, and our drivers follow strict hygiene and safety measures to ensure a clean and comfortable journey.',
  },
  {
    question: 'Is customer support available during the Pune to Lonavala cab trip?',
    answer: 'Yes, our dedicated 24×7 customer support team is available to assist you throughout your Pune to Lonavala journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Nilesh Patil',
    feedback: 'I booked a Pune to Lonavala cab with Sai Trupti Cabs. The experience was fantastic—smooth booking, polite driver, and a clean car.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Kavita Joshi',
    feedback: 'Sai Trupti Cabs provided excellent service for our Pune to Lonavala trip. Comfortable journey and great customer support!',
    rating: 5,
  },
];




















































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Lonavala Cab Booking",
  "image": "https://saitrupticabs.com/assets/images/pune-to-lonavala-cab.jpg",
  "description": "Book cabs from Pune to Lonavala for weddings, corporate trips, or leisure travel. Choose from AC, Non-AC, Innova, Ertiga, or luxury cabs. Affordable online booking available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4600"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1299",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-lonavala-cab-booking"
  }
};






  return (
    <div>
      <Helmet>
  <title>Pune to Lonavala Cab Booking | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book cabs from Pune to Lonavala for weddings, corporate trips, or leisure travel. Choose from AC, Non-AC, Innova, Ertiga, or luxury cabs. Affordable online booking available 24x7." 
  />
  <meta 
    name="keywords" 
    content="Pune to Lonavala Cab Booking, Pune to Lonavala Taxi, Pune to Lonavala Car Hire, Pune to Lonavala AC Cab, Pune to Lonavala Non AC Cab, Pune to Lonavala Luxury Cab, Pune to Lonavala Innova Cab, Pune to Lonavala Ertiga Cab, Pune to Lonavala Outstation Cab, Pune to Lonavala Drop Cab, Affordable Pune to Lonavala Cab, Pune to Lonavala One Way Cab, Pune to Lonavala Corporate Cab, Pune to Lonavala Wedding Cab, Pune to Lonavala Online Booking" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/36.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetolonavalacabbooking;